import {apiHelper} from "../redux/apiHelper"
export const getCmsFaqSection=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-faq-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsFaqSection=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-faq-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsFaqSection=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-faq-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsFaqSectionById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-faq-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsFaqSectionById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-faq-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}